import { z } from "zod";
import { zId } from "./common.js";

/**
 * Direct mail: letter templates + merge runs. Templates are HTML with merge
 * tokens (the email vocabulary plus letter-specific address/salutation
 * tokens); runs merge a segment into one PDF plus a mail-house CSV.
 */

export const LETTER_MERGE_TOKENS = [
  { token: "{{addressBlock}}", label: "Address block", description: "Recipient name + mailing address lines" },
  { token: "{{date}}", label: "Today's date", description: "Today's date, written out" },
  { token: "{{salutation}}", label: "Salutation", description: "“Dear First,” greeting line" },
  { token: "{{firstName}}", label: "First name", description: "First name (falls back to full name)" },
  { token: "{{name}}", label: "Full name", description: "Full display name" },
  { token: "{{lifetimeGiving}}", label: "Lifetime giving", description: "Lifetime giving total" },
  { token: "{{lastGiftAmount}}", label: "Last gift amount", description: "Most recent gift amount" },
  { token: "{{lastGiftDate}}", label: "Last gift date", description: "Most recent gift date" },
] as const;

export const zUpsertLetterTemplate = z.object({
  name: z.string().trim().min(1).max(200),
  /** letter body HTML: p, h1–h3, strong/em/u, ul/ol/li, blockquote, hr, br */
  bodyHtml: z.string().trim().min(1).max(50_000),
});
export type UpsertLetterTemplate = z.infer<typeof zUpsertLetterTemplate>;

export const zCreateMailRun = z.object({
  name: z.string().trim().min(1).max(200),
  templateId: zId,
  segmentId: zId,
  /** CT-RM-29: addresses NCOA flagged undeliverable / moved-left-no-forwarding are skipped unless this is set */
  includeUndeliverable: z.boolean().default(false),
});
export type CreateMailRun = z.infer<typeof zCreateMailRun>;

export const MAIL_RUN_STATUSES = ["ready", "sent_to_print", "failed"] as const;
export const zMailRunStatus = z.enum(MAIL_RUN_STATUSES);
export type MailRunStatus = z.infer<typeof zMailRunStatus>;

export const MAIL_PIECE_STATUSES = ["rendered", "queued", "sent", "failed"] as const;
export const zMailPieceStatus = z.enum(MAIL_PIECE_STATUSES);
